import { Navigate, Route, Routes } from "react-router-dom";
import Header from "../../components/shared/Header";
import Issues from "../../containers/pages/issues/Issues";
import Member from "../../containers/pages/members/Member";
import Profile from "../../containers/pages/profile/Profile";
import PasswordReset from "../../containers/pages/profile/Passwordreset";
import BookedTime from "../../containers/pages/time/BookedTime";
import TasksAssigned from "../../containers/pages/tasks/TaskAssigned";
import Booking from "../../containers/pages/bookings/admin/Booking";
import UserBooking from "../../containers/pages/bookings/user/UserBooking";
import ActivityLog from "../../containers/pages/bookings/admin/ActivityLog";
import MessageCreate from "../../containers/pages/messages/MessageCreate";
import MessageDetails from "../../containers/pages/messages/MessageDetails";
import FeedDetails from "../../containers/pages/feeds/FeedDetails";
import Dashboard from "../../containers/pages/dashboard/Dashboard";
import KPI from "../../containers/pages/kpi/KPI";
import Project from "../../containers/pages/projects/Project";
import ProjectCreate from "../../containers/pages/projects/ProjectCreate";
import ProjectDetails from "../../containers/pages/projects/ProjectDetails";
import { useSelector } from "react-redux";
import {
  canEditModule,
  canViewModule,
  getModulePermissions,
  isBookingAdmin,
} from "../../utils/moduleAccess";

export function Admin({ usersession }) {
  const authState = useSelector((state) => state.auth);
  const modulePermissions = getModulePermissions(authState);
  const isBookingAdminUser = isBookingAdmin(authState);

  const canViewProject = canViewModule(modulePermissions, "project");
  const canViewBooking = canViewModule(modulePermissions, "booking");
  const canEditBooking = canEditModule(modulePermissions, "booking") && isBookingAdminUser;
  const canViewPeople = canViewModule(modulePermissions, "people");
  const canViewKpi = canViewModule(modulePermissions, "kpi");
  const canViewCommunications = canViewModule(modulePermissions, "communications");

  return (
    <div className="App">
      <Header showOverview={true} />
      <div className="mt-2 lg:mt-3 overflow-hidden">
        <Routes>
          <Route
            path="/projects/create"
            element={canViewProject ? <ProjectCreate /> : <Navigate to="/" replace />}
          />
          <Route
            path="/projects/:name/:status"
            element={canViewProject ? <ProjectDetails /> : <Navigate to="/" replace />}
          />
          <Route
            path="/projects"
            element={canViewProject ? <Project /> : <Navigate to="/" replace />}
          />
          <Route path="/availability" element={<Navigate to="/" replace />} />
          <Route
            path="/bookings"
            element={canViewBooking ? (canEditBooking ? <Booking /> : <UserBooking />) : <Navigate to="/" replace />}
          />
          <Route
            path="/bookings/activity-log"
            element={canEditBooking ? <ActivityLog /> : <Navigate to="/" replace />}
          />
          <Route
            path="/people"
            element={canViewPeople ? <Member /> : <Navigate to="/" replace />}
          />
          {canViewCommunications ? (
            <Route path="/messages" element={<MessageCreate />} />
          ) : null}
          <Route path="/notifications/messages/:id" element={<MessageDetails />} />
          <Route path="/feeds/:id" element={<FeedDetails />} />
          <Route path="/issues" element={<Issues />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/change-password" element={<PasswordReset />} />
          <Route path="/teamwork-time" element={<BookedTime />} />
          <Route path="/tasks-assigned" element={<TasksAssigned />} />
          <Route
            path="/kpi/*"
            element={canViewKpi ? <KPI /> : <Navigate to="/" replace />}
          />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/" element={<Dashboard />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </div>
    </div>
  );
}
